<template>
  <div class="login_container">
    <div class="img-form">
      <div class="avatar_box">
        <img src="../assets/images/login/bg2.png" alt="">

        <el-dropdown class="message-wrap" placement="bottom" :show-timeout="0">
          <el-button type="primary" size="mini" plain>{{ $t('_lang') }}</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(val, key) in i18nMessages" :key="key" @click.native="changeLang(key)">{{ val._lang }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div class="footer-container">
          <!--        <div class="footer">千仓科技供应链，专注中日国际物流</div>-->
          <!--        <div class="about">Copyright © www.zxwl.com, All Rights Reserved.</div>-->
        </div>
      </div>
      <div class="login_box pon">
        <!-- 表单 -->
        <div class="login_box_content">
          <div class="img-container">
            <!--            <img src="../assets/images/login/login_biaoti.png" alt="">-->
            <img src="../assets/images/login/login_biaoti6.png" alt="">
          </div>
          <el-form ref="LoginFormRef" :model="loginForm" label-width="0" :rules="LoginFormRules" class="login_form">
            <el-form-item prop="userName">
              <el-input v-model="loginForm.userName" prefix-icon="el-icon-user-solid" :placeholder="$t('login.login1')">
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" type="password" :placeholder="$t('loginR.login16')"
                @keyup.enter.native="login"></el-input>
            </el-form-item>
            <div style="display: flex;flex-direction: column;">
              <div>
                <span style="float:left;height:22px;line-height:20px;">
                  <el-link type="primary" :underline="false" @click="logisticsUrl">{{$t('logistics.logistics1')}}</el-link>
                </span>
                <el-link type="info" style="float:right;font-size: 10px;" :underline="false" @click="resetPassword">
                  <span style="font-size: 10px;">{{$t('loginR.login1')}}</span>
                </el-link>
              </div>
              <div style="margin-top: 5px">
                <el-checkbox size="mini" v-model="loginForm.rememberPassword">{{$t('login.login35')}}</el-checkbox>
              </div>
            </div>
            <el-button class="btns" type="primary" @click="login" size="small"><span>{{$t('login.login2')}}</span></el-button>
          </el-form>
        </div>
        <div class="registerText" style="overflow:hidden;justify-content: right">
          <!--<span style="float:left;height:22px;line-height:22px;margin-right:5px">{{$t('loginR.login2')}}</span>-->
          <span style="height:22px;line-height:20px;margin-right: 30px">
            <el-link type="primary" :underline="false" @click="register">{{$t('loginR.login8')}}</el-link>
          </span>
        </div>
        <!-- 物流查询 -->
        <!-- <div class="registerText" style="overflow:hidden">
           <span  style="float:left;height:22px;line-height:20px"><el-link type="primary" :underline="false" @click="logisticsUrl">{{$t('logistics.logistics1')}}</el-link></span>
        </div> -->

        <div class="filing">
          <a href="https://beian.miit.gov.cn/" target="_blank">@アリパートナーズシステム</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { messages, setLang } from '@/i18n'
import Cookies from "js-cookie"
import { encrypt, decrypt } from '@/utils/jsencrypt'

export default {
  data () {
    return {
      i18nMessages: messages,
      loginForm: {
        userName: '',
        password: ''
      },
      rememberPassword: false,
      LoginFormRules: {
        userName: [
          { required: true, message: this.$t('login.login3'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('loginR.login16'), trigger: 'blur' },
        ]
      }
    }
  },
  created () {
    this.getCookie()
  },
  methods: {
    getCookie () {
      const userName = Cookies.get("userName")
      const password = Cookies.get("password")
      const rememberPassword = Cookies.get('rememberPassword')
      this.loginForm = {
        userName: userName === undefined ? this.loginForm.userName : userName,
        password: password === undefined ? this.loginForm.password : decrypt(password),
        rememberPassword: rememberPassword === undefined ? false : Boolean(rememberPassword)

      }
    },
    changeLang (key) {
      this.$i18n.locale = key
      setLang(key)
    },
    resetPassword () {
      this.$router.push({
        name: 'resetPassword'
      })
    },
    resetLoginForm () {
      this.$refs.LoginFormRef.resetFields()
    },
    login () {
      this.$refs['LoginFormRef'].validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post('admin/login', this.loginForm)
          if (res.code == 200 && res.data.userRead == '1') {
            this.$message({
              message: this.$t('login.login4'),
              type: 'success',
              duration: 500
            })
            window.sessionStorage.setItem('token', res.data.tokenHead + res.data.token)
            if (this.loginForm.rememberPassword) {
              Cookies.set("userName", this.loginForm.userName, { expires: 30 })
              Cookies.set("password", encrypt(this.loginForm.password), { expires: 30 })
              Cookies.set('rememberPassword', this.loginForm.rememberPassword, { expires: 30 })
            } else {
              Cookies.remove("userName")
              Cookies.remove("password")
              Cookies.remove('rememberPassword')
            }
            //权限数组
            // var authArr = ['add','edit'];
            // window.sessionStorage.setItem('auth',authArr.toString());
            this.$router.push('/')
          } else if(res.code == 200 && res.data.userRead == '0'){
            window.sessionStorage.setItem('token', res.data.tokenHead + res.data.token)
            if (this.loginForm.rememberPassword) {
              Cookies.set("userName", this.loginForm.userName, { expires: 30 })
              Cookies.set("password", encrypt(this.loginForm.password), { expires: 30 })
              Cookies.set('rememberPassword', this.loginForm.rememberPassword, { expires: 30 })
            } else {
              Cookies.remove("userName")
              Cookies.remove("password")
              Cookies.remove('rememberPassword')
            }
            this.$modalDialog(() => import('./login-dialog.vue'), {
            }).then(
                () => {
                  this.$message({
                    message: this.$t('login.login4'),
                    type: 'success',
                    duration: 500
                  })
                  this.$router.push('/')
                },
                () => {
                }
            )
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        } else {
          return false
        }
      })
    },
    register () {
      window.sessionStorage.clear
      this.$router.push({ name: 'register' })
    },
    // 跳转到物流查询
    logisticsUrl () {
      this.$router.push({ name: 'logisticsInfo' })
    },
  }
}
</script>

<style lang="less" scoped>
.el-form-item {
  height: 40px !important;
}
.el-input__inner {
  font-size: inherit;
}
.login_container {
  height: 100%;
  width: 100%;
  // background: url("../assets/images/login/bg.png") no-repeat;
  background-size: cover;
}
//.login_box{
//  position: relative;
//}
.registerText {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  // position: absolute;
  // bottom: -4%;
  // right: 26%;
}
.login_box_content {
  //padding: 15%;
  //padding-top: 45%;
  .img-container {
    padding-bottom: 20px;
    img {
      //width: 188px;
      height: 77px;
    }
  }
}

.img-form {
  overflow: hidden;
  height: 100%;
  position: relative;
  .avatar_box {
    position: relative;
    //float: left;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
    .message-wrap {
      position: absolute;
      top: 30px;
      right: 30px;
    }
  }
  .login_box {
    //float: left;
    position: absolute;
    width: 290px;
    height: 326px;
    left: 208px;
    //margin: 0 auto;
    top: 50%;
    margin-top: -163px;
    //background-color: red;
  }
}
@media screen and (min-width: 1600px) {
  //.avatar_box{
  //  width: 75% !important;
  //}
  //.login_box{
  //  width: 25% !important;
  //}
}

.login_form {
  bottom: 0;
  width: 100%;
  padding: 0px;
  box-sizing: border-box;
}
.btns {
  margin-top: 20px;
  width: 263px;
  height: 38px;
  background: linear-gradient(90deg, #269f98, #2e85a1);
  border-radius: 20px;
  color: #ffffff;
}
.btns span {
  font-size: 17px !important;
  letter-spacing: 5px;
}

/deep/ .el-input__prefix,
.el-input__suffix {
  color: #2e85a1 !important;
}

/deep/ .el-input__icon .el-icon-user-solid {
  color: #2e85a1 !important;
}
.footer-container {
  width: 100%;
  position: absolute;
  bottom: 10%;
  text-align: center;
}
.footer {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  letter-spacing: 4px;
  color: #fefeff;
}

.about {
  font-size: 16px;
  font-family: Source Han Sans CN;
  // font-weight: 400;
  color: #fefeff;
  padding-top: 10px;
}
/deep/ .el-input__inner {
  border: none !important;
  border-bottom: 1px solid #e5e9f8 !important;
}
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 40px !important;
}
.pon {
  position: relative;
  .filing {
    position: fixed;
    left: 47%;
    bottom: 20px;
  }
}
</style>
